import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { AuthService } from '@app/modules/auth/services/auth.service'
import { BetaFeaturesService } from './beta-features.service'

/**
 * HTTP Interceptor that adds enabled beta features to outgoing requests
 * via the X-Beta-Features header.
 *
 * This interceptor only adds the header if:
 * 1. The user is a super admin (is_admin = true)
 * 2. There are enabled beta features in localStorage
 *
 * The header value is a comma-separated list of enabled feature keys.
 * Example: "database_ai_search,another_feature"
 */
export const BetaFeaturesInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService)
  const betaFeaturesService = inject(BetaFeaturesService)

  // Exclude external APIs that don't support custom headers (CORS issues)
  if (req.url.startsWith('https://maps.googleapis.com/maps/api/timezone')) {
    return next(req)
  }

  // Get enabled features
  const enabledFeatures = betaFeaturesService.getEnabledFeaturesHeader()

  // Only super admins can send beta features header
  if (!authService.isAdmin) {
    return next(req)
  }

  // If no features are enabled, don't add the header
  if (!enabledFeatures) {
    return next(req)
  }

  // Clone the request and add the X-Beta-Features header
  const modifiedRequest = req.clone({
    setHeaders: {
      'X-Beta-Features': enabledFeatures
    }
  })

  return next(modifiedRequest)
}
